export default {
  field__account_number: 'Numero de cuenta',
  field__document_type: 'Tipo de documento',
  field__document_id: 'Numero de documento',
  field__account_holder: 'Nombre del titular de la cuenta',
  field__bank_name: 'Nombre del banco',
  field__bank_code: 'Código del banco',
  field__account_holder_address: 'Dirección del titular de la cuenta',
  field__bank_address: 'Dirección del banco',
  field__bic: 'BIC (código de indentificación bancaria)',
  field__purpose_of_payment: 'Propósito del pago',
  field__pay_id: 'ID de pago',
  field__card_last_four_digits: 'Los últimos cuatro dígitos de la tarjeta',
  field__invoice_receipt_number: 'Número de recibo de factura',
};
